<div class="profile-widget">
  <div class="profile-widget__avatar-container">
    <app-profile-avatar
      [profileAvatarUrl]="imageAvatarUrl"
    ></app-profile-avatar>
    <h3>{{ profile | profileDisplayName }}</h3>
  </div>
  <app-profile-completeness
    class="profile-widget__completeness"
    [profile]="profile"
    [variant]="'compact'"
    [showAction]="true"
    (action)="goToPage(appRoutes['PROFILE'].fullPath)"
  ></app-profile-completeness>

  <span class="profile-widget__version"
    >v{{ appVersion }} | {{ appBuildDate }}</span
  >
  <div class="profile-widget__list">
    <div
      (click)="goToPage(appRoutes['PROFILE'].fullPath)"
      class="profile-widget__item"
    >
      <div class="profile-widget__item-label-container">
        <fa-icon [icon]="['fas', 'circle-user']" class="profile-widget__item-icon"></fa-icon>
        <span class="profile-widget__item-label">
          {{ 'PROFILE.TITLE' | translate }}
        </span>
      </div>
      <fa-icon [icon]="['fas', 'chevron-right']" class="profile-widget__arrow-icon"></fa-icon>
    </div>
    <div (click)="logout()" class="profile-widget__item">
      <div class="profile-widget__item-label-container">
        <fa-icon [icon]="['fas', 'arrow-right-from-bracket']" class="profile-widget__item-icon"
         
        ></fa-icon>
        <span class="profile-widget__item-label">
          {{ 'AUTHENTICATION.LOGOUT_TITLE' | translate }}
        </span>
      </div>
      <fa-icon [icon]="['fas', 'chevron-right']" class="profile-widget__arrow-icon"></fa-icon>
    </div>
  </div>
</div>
